import axios from '../../../helpers/axios-setup';
import { AppCertification } from '../../../redux/modules/application-flow';

export const saveCapabilities = (appId: number, params: AppCertification[]) =>
  axios.patch(`/applications/builder/capabilities/${appId}`, params);
